import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import './Businessman.css'

const Businessman = (props) => {
    // console.log('clicked');

    const { name, net_worth, rank, age, country, industry, img, source } = props.billionaire;

    return (
        <div>
            <div className="col">
                <div className="card h-100 card-style">
                    <img src={img} className="card-img-top my-3 img-style" alt="..."/>
                    <div className ="card-body">
                        <h5 className ="card-title fw-bold">{name}</h5>
                        <p><strong>Age:</strong> {age}</p>
                        <p><strong>NetWorth:</strong> ${net_worth}B</p>
                        <p><strong>Rank:</strong> {rank}</p>
                        <p><strong>Industry:</strong> {industry}</p>
                        <p><strong>Country:</strong> {country}</p>
                        <button
                            onClick = {() => props.handleAddToCart(props.billionaire)}
                            className='btn btn-outline-success'><i class="fas fa-shopping-cart"></i> Hire for get idea
                        </button>
                        <h2><i class="fab fa-google-plus-square"></i>  <i class="fab fa-facebook-square"></i></h2>
                        
                    </div>
                    <div className ="card-footer">
                        <small className="text-muted"><strong><i class="fas fa-info-circle"></i>  Source:</strong> {source} <i class="fas fa-money-check-alt"></i></small>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Businessman;